import { useWispoUnreadCount } from '@webinex/wispo';
import { wispoClient } from './wispoClient';

export function useAppWispoUnreadCount() {
  return useWispoUnreadCount(wispoClient);
}
